import { render, staticRenderFns } from "./RetentionCentreData.vue?vue&type=template&id=18ae2a12&scoped=true"
import script from "./RetentionCentreData.vue?vue&type=script&lang=js"
export * from "./RetentionCentreData.vue?vue&type=script&lang=js"
import style0 from "./RetentionCentreData.vue?vue&type=style&index=0&id=18ae2a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae2a12",
  null
  
)

export default component.exports